import './App.css';
import {useEffect, useState} from "react";
import axios from "axios";

function App() {
    const baseApiUrl = "https://crawler.maik.software"
    const [championships, setChampionships] = useState([]);

    const [selectedChampionship, setSelectedChampionship] = useState(championships[0])
    const [selectedClub, setSelectedClub] = useState("");

    const [availableFiles, setAvailableFiles] = useState([]);

    const [disabled, setDisabled] = useState(false)

    useEffect(() => {
        axios.get(`${baseApiUrl}/files`)
            .then(response => {
                setAvailableFiles(response.data);
            })
            .catch(error => {
                console.log(error)
            });
    }, []);

    useEffect(() => {
        axios.get(`${baseApiUrl}/championships`)
            .then(response => {
                const responseData = response.data;

                const keys = Object.entries(responseData).map((championship) => championship[0])

                const allChampionships = keys.map((key) => {
                    return {
                        league: key,
                        clubs: responseData[key].clubs.map(club => club.name)
                    }
                })

                setChampionships(allChampionships)
            })
            .catch(error => {
                console.log(error)
            });
    }, []);

    useEffect(() => {
        setSelectedChampionship(championships[0])
    }, [championships]);

    useEffect(() => {
        if (!selectedChampionship) return
        setSelectedClub(selectedChampionship.clubs[0])
    }, [selectedChampionship]);

    const downloadFile = (id, club) => {
        const today = new Date()
        const year = today.toLocaleString("default", {year: "2-digit"})
        const month = today.toLocaleString("default", {month: "2-digit"})
        const day = today.toLocaleString("default", {day: "2-digit"})

        const fileName = `${year}${month}${day}_${club}`

        axios.post(`${baseApiUrl}/download-file`, {
            file_id: id
        }, {
            responseType: "blob"
        }).then(response => {
            const href = URL.createObjectURL(response.data);

            const link = document.createElement("a")
            link.href = href



            link.setAttribute("download", fileName + '.docx');

            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        }).catch(error => {
            console.log(error)
        })
    }

    const createNewFile = () => {
        setDisabled(true)
        axios.post(`${baseApiUrl}/create-file`, {
            championship: selectedChampionship.league,
            club: selectedClub
        }).catch(error => {
            console.log(error)
        }).finally(() => {
            setDisabled(false)
            axios.get(`${baseApiUrl}/files`)
                .then(response => {
                    setAvailableFiles(response.data);
                })
                .catch(error => {
                    console.log(error)
                });
        })
    }


    return (
        <div className="App">
            <header className="App-header">
                <div>
                    <label>Wettbewerb: </label>
                    <select onChange={e => {setSelectedChampionship(championships[e.target.value]); setSelectedClub(championships[e.target.value].clubs[0])}}>
                        {championships.map((championship, index) => (
                            <option value={index}>{championship.league}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label>Mannschaft: </label>
                    <select onChange={e => setSelectedClub(e.target.value)} value={selectedClub}>
                        {championships.length > 0 && selectedChampionship && selectedChampionship.clubs.map((club) => (
                            <option value={club}>{club}</option>
                        ))}
                    </select>
                </div>

                <button onClick={() => createNewFile()} disabled={disabled}>Generiere neue Datei</button>

                <table>
                    <thead>
                        <tr>
                            <th>Club</th>
                            <th>Liga</th>
                            <th>Datum</th>
                            <th>Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        {availableFiles.map((file) => (
                            <tr>
                                <td>{file.club}</td>
                                <td>{file.championship}</td>
                                <td>{new Date(file.cr_date).toLocaleString("DE-de", {timeZone: "GMT",year: "numeric",
                                    month: "long",
                                    day: "numeric",})}</td>
                                <td><button onClick={() => downloadFile(file.id, file.club)} disabled={file.status !== "success"}>Download</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>

            </header>
        </div>
    );
}

export default App;
